// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3c75aa1a","453":"139ad33f","455":"3de66aaf"}[chunkId] + ".chunk.js";
};